import { render, staticRenderFns } from "./05.vue?vue&type=template&id=5fedb2e0&"
import script from "./05.vue?vue&type=script&lang=js&"
export * from "./05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports